import React, { memo } from 'react';

import { AuthLayoutDesktop } from './AuthLayoutDesktop';

interface Props {
	className?: string;
	children: React.ReactNode;
	id?: string;
	isInvestorApp?: boolean;
}

const AuthLayout = ({ className, isInvestorApp, children }: Props) => {
	const Layout = AuthLayoutDesktop;

	return (
		<Layout className={className} isInvestorApp={isInvestorApp}>
			{children}
		</Layout>
	);
};
const _AuthLayoutExport = memo(AuthLayout);

export { _AuthLayoutExport as AuthLayout };
